export default __webpack_public_path__ + "static/media/capsule-landing-shadow.78ae1e06.png";